import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWarningYellow16 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#F9CC15",
		d: "m6.275 2.443-5.01 8.546C.484 12.322 1.445 14 2.991 14h10.018c1.546 0 2.507-1.678 1.726-3.011l-5.01-8.546c-.772-1.318-2.678-1.318-3.45 0"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#2B0E3F",
		d: "M8.75 9V5h-1.5v4zM8.75 11.5V10h-1.5v1.5z"
	})]
});
const ForwardRef = forwardRef(SvgIconWarningYellow16);
export default ForwardRef;
